export enum CloudServiceEnum {
  CloudStorage = 'Cloud',
  GoogleDrive = 'GoogleDrive',
  OneDrive = 'OneDrive',
  DropBox = 'Dropbox'
}

export enum RedirectCloudUrl {
  OneDrive = 'one-drive',
  Dropbox = 'dropbox',
}
